import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M10.3686 3C6.29743 3 3 6.23129 3 10.2208C3 14.2102 6.29743 17.4415 10.3686 17.4415C14.4397 17.4415 17.7371 14.2102 17.7371 10.2208C17.7371 6.23129 14.4397 3 10.3686 3ZM10.3686 15.6363C7.31982 15.6363 4.84214 13.2083 4.84214 10.2208C4.84214 7.23317 7.31982 4.80519 10.3686 4.80519C13.4173 4.80519 15.895 7.23317 15.895 10.2208C15.895 13.2083 13.4173 15.6363 10.3686 15.6363ZM20.7306 19.4633C21.0898 19.8153 21.0898 20.384 20.7306 20.736C20.3714 21.088 19.7911 21.088 19.4319 20.736L15.6831 17.1707L16.9818 15.8981L20.7306 19.4633Z' />
        </SvgIcon>
    );
});
